
export enum JobType {
    Any = "1",
    Contract = "2",
    Permanent = "3",
    Temporary = "4",
    GarduateTrainee = "5",
    WorkFromHome = "6",
    PartTime = "7",
}